import { useHistory, useLocation } from "react-router";
import PageHeader from "../../../common/PageHeader";

import "./style.scss";
import "./style.darkmode.scss";
import BroadcastFilter from "../broadcast-filter";
import { connect } from "react-redux";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
    setAlert,
    setBroadcastModal,
    setSettings,
    setStashModal,
    updateBroadcastIndicator,
    updateBroadcastMsgR,
    updateShowPriceR,
} from "../../../../redux/actions";
import NewMessageUserMultiSelect from "../NewMessageUserMultiSelect";
import { ROLES } from "../../../utils/constants";
import Exclude from "../Exclude";
import PTextareaBroadcast from "../../../common/PTextareaBroadcast";
import PriceText from "../../../common/PriceText";
import {
    Checkbox,
    FormControlLabel,
    IconButton,
    useMediaQuery,
} from "@mui/material";
import { ModalPPVPriceContext } from "../../../common/ModalPPVPrice/context";
import ModalPPVPrice from "../../../common/ModalPPVPrice";
import { ppvPrice as DefaultPpvPrice } from "../../../utils/rules";
import {
    setStashSelectedR,
    setStashShow,
    setStashSidebar,
    setStashTabSelected,
    setTempSelected,
} from "../../../../redux/actions/stash";
import Stash from "../../../common/Stash";
import StashSelected from "../stash-selected";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import styled from "styled-components";
import { MessageContext } from "../MessageContext";
import { resetMessageUserListsFilter } from "../../../../redux/actions/message";
import { useDropzone } from "react-dropzone";
import { bytesToSize } from "../../../utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { isDesktop, isMobile } from "react-device-detect";
import Meta from "../../../common/Meta";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";

const PriceInformation = styled.div`
    background-color: #eee;
    color: #0097fe;
    padding: 8px 8px 8px 16px;
    margin: 8px 0;
    position: relative;
    border-radius: 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ClosePriceInformation = styled.span``;

const NewMessage = ({
    userDetails,
    showPrice,
    stashSelected,
    stashModal,
    settings,
    stashSidebar,
    broadcastModal,
    show,

    setStashSelected,
    updateShowPrice,
    setSettings,
    setBroadcastModal,
    setStashShow,
    updateBroadcastIndicator,
    setStashTabSelected,
    updateBroadcastMsg,
    setStashModal,
    setStashSidebar,
    messageUserListsFilterRdx,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width: 899px)");

    const [minPpvPrice, setMinPpvPrice] = useState(DefaultPpvPrice.minAmount);
    const [maxPpvPrice, setMaxPpvPrice] = useState(DefaultPpvPrice.maxAmount);
    const [title, setTitle] = useState("New Message");
    const [selectedFilter, setSelectedFilter] = useState("");
    const [newMsgChecked, setNewMsgChecked] = useState("");
    const [newMsgStep, setNewMsgStep] = useState("1");
    const [userCount, setUserCount] = useState(0);
    const [newMsgSendSelected, setNewMsgSendSelected] = useState([]);
    const [rangeIdFromParent, setRangeIdFromParent] = useState("");
    const [rangeIdToParent, setRangeIdToParent] = useState("");
    const [rangeDateFromParent, setRangeDateFromParent] = useState("");
    const [rangeDateToParent, setRangeDateToParent] = useState("");
    const [lastSubsParent, setLastSubsParent] = useState(1);
    const [pastHoursParent, setPastHoursParent] = useState(1);
    const [excluded, setExcluded] = useState([]);
    const [newSubsError, setNewSubsError] = useState("");
    const [nextLoading, setNextLoading] = useState(false);
    const [excludeList, setExcludeList] = useState([]);
    const [broadcastMessage, setBroadcastMessage] = useState("");
    const [ppvPrice, setPpvPrice] = useState("");
    const [newLineCount, setNewLineCount] = useState(1);
    const [promoPrice, setPromoPrice] = useState("");
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [prevPpvPrice, setPrevPpvPrice] = useState("");
    const [prevPromoPrice, setPrevPromoPrice] = useState("");
    const [prevIsDiscounted, setPrevIsDiscounted] = useState(false);
    const [expiry, setExpiry] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
    });
    const [prevExpiry, setPrevExpiry] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
    });
    const [disableBroadcastSendMessage, setDisableBroadcastSendMessage] =
        useState(true);
    const [sending, setSending] = useState(false);
    const [ppvPriceError, setPpvPriceError] = useState(false);
    const [files, setAttach] = useState([]);
    const [onComposeMessage, setOnComposeMessage] = useState(false);
    const [openModalBroadcast, setOpenModalBroadcast] = useState(false);
    const [isResend, setIsResend] = useState(false);
    const [resending, setResending] = useState(false);
    const [freePreview, setFreePreview] = useState({});
    const [reshuffled, setReshuffled] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const [broadcastId, setBroadcastId] = useState("");
    const [sendBy, setSendBy] = useState("sub_id");
    const [filesizeErrors, setFilesizeErrors] = useState([]);
    const maxFileSize = 1610612736; // 1.5GB
    const [tmpStashSelection, setTmpStashSelection] = useState([]);
    const [newMessageSelect, setNewMessageSelect] = useState(0);
    const [mediaOrAlbum, setMediaOrAlbum] = useState("media");
    const [editAlbum, setEditAlbum] = useState("");
    const [images, setImages] = useState([]); // su
    const [progressbar, setProgressbar] = useState(0);
    const [fileLoadingText, setFileLoadingText] = useState("");
    const [message, setMessage] = useState("");
    const [isUploading, setIsUploading] = useState(false);
    const [subTitle, setSubTitle] = useState("");
    const [sendEmail, setSendEmail] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem("user"));

    const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
        useDropzone({
            onDropRejected,
            onDrop: (images) =>
                onDrop(
                    images,
                    mediaOrAlbum,
                    editAlbum,
                    userDetails.role,
                    settings
                ),
            maxSize: maxFileSize,
            accept: "image/jpeg, image/png, video/mp4, video/quicktime",
        });

    const onDrop = useCallback(
        (images, mediaOrAlbum, editAlbum, userRole, settings) => {
            if (images.length > parseInt(settings.max_stash_file_uploads)) {
                dispatchAlert(
                    `
                    <p>
                        Your attempt to upload ${
                            images.length
                        } media files all at once is not allowed.
                    </p>
                    <p>
                        You are permitted to upload up to ${
                            settings.max_stash_file_uploads || 25
                        } media files at a time from your device.
                    </p>
                `,
                    "error"
                );

                return;
            }

            let sumFileSize = 0;
            images.forEach((file) => {
                sumFileSize += file.size;
            });

            if (sumFileSize > maxFileSize) {
                dispatchAlert(
                    `
                    <p>The selected media size exceeds the ${bytesToSize(
                        maxFileSize
                    )} amount that can be done in the one upload step.</p>
                    <p>Please make a smaller selection of media that total less than <b>${bytesToSize(
                        maxFileSize
                    )}</b> and try to upload again.</p>
                `,
                    "error"
                );

                return;
            }

            setImages([...images]);
            const curr_images = images;
            const formData = new FormData();

            setProgressbar(0);
            setFileLoadingText("");

            if (userRole == ROLES.SU) {
                // separate upload process for SU
                // const files = e.target.files || e.dataTransfer.files;
                const clips = [];
                let i = 0;

                images.forEach((file) => {
                    formData.append("files[]", file);
                    clips[i] = file;
                    setAttach([...clips]);
                    i++;
                });

                setSending(true);

                formData.append(
                    "sender_id",
                    localStorage.getItem("loggedin_user")
                );

                setMessage("");
                setImages([]);
                setShowLoader(true);
                setIsUploading(true);

                axios({
                    method: "post",
                    url: "/api/stash-upload",
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" },
                })
                    .then((data) => {
                        // handle success
                        setShowLoader(false);
                        setStashSelected([data.data.media]);
                        // reloadAlbumList();
                        setSending(false);
                        setIsUploading(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                        console.error({ error });
                        setSending(false);
                        setIsUploading(false);
                    });
            } else {
                images.forEach((file) => {
                    curr_images.push(file);
                    formData.append("files[]", file);
                });

                setSending(true);

                const images_upload = images;
                const config = {
                    headers: { "Content-Type": "multipart/form-data" },
                };
                const total_files = images.length;
                const uploaded = 0;

                formData.append(
                    "sender_id",
                    localStorage.getItem("loggedin_user")
                );

                if (mediaOrAlbum == "view_album") {
                    formData.append("edit_album", editAlbum);
                }

                setMessage("");
                setImages([]);
                setShowLoader(true);
                setIsUploading(true);

                axios({
                    method: "post",
                    url: "/api/stash-upload",
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (progressEvent) => {
                        const loaded = parseInt(
                            Math.round(
                                (progressEvent.loaded / progressEvent.total) *
                                    100
                            )
                        );

                        setProgressbar(loaded);
                        if (loaded == 100) {
                            setFileLoadingText("Processing media...");
                        }
                    },
                })
                    .then((data) => {
                        if (editAlbum != "") {
                            reloadAlbumList();
                        }
                        setIsUploading(false);
                        setShowLoader(false);
                        setSending(false);
                    })
                    .catch((error) => {
                        console.error({ error });
                        setShowLoader(false);
                        setIsUploading(false);
                        setShowLoader(false);

                        if (error.response && error.response.status === 422) {
                            let tmp = "";
                            Object.keys(error.response.data.errors).forEach(
                                (key) => {
                                    tmp += `${error.response.data.errors[key][0]}<br />`;
                                }
                            );

                            dispatchAlert(tmp, "error");
                        }

                        setSending(false);
                    });
            }
        },
        []
    );

    useEffect(() => {
        if (filesizeErrors.length > 0) {
            let tmp = `<p>The media file you tried to upload is too big.  The maximum size is ${bytesToSize(
                maxFileSize
            )}</p><ul>`;
            filesizeErrors.forEach((error) => {
                tmp += `<li>Media file name: ${error.filename}</li>`;
            });
            tmp += "</ul><p>Tip: Try trimming your media and upload again.</p>";

            dispatchAlert(tmp, "error", "Media file is too big to upload");
        }
    }, [filesizeErrors]);

    const onDropRejected = useCallback((errors) => {
        const tmpErrors = [];
        errors.forEach((error) => {
            if (error.errors.find((e) => e.code === "file-too-large")) {
                tmpErrors.push({
                    filename: error.file.name,
                });
            }
        });
        if (tmpErrors.length > 0) {
            setFilesizeErrors(tmpErrors);
        }
    }, []);

    const resetBroadcastForm = () => {
        setSending(false);
        setPpvPriceError("");
        updateShowPrice(false);
        setPpvPrice("");
        setStashSelected([]);
        setBroadcastMessage("");
        updateBroadcastMsg("");
    };

    const handleSelectFreePreview = useCallback(
        (media) => {
            if (Object.keys(media).length > 0) {
                if (media.media_id == freePreview.media_id) {
                    setFreePreview({});
                } else {
                    setFreePreview(media);
                    const index = stashSelected.findIndex(
                        (s) => s.media_id == media.media_id
                    );
                    const tmp = [...stashSelected];
                    if (index >= 0) {
                        const selected = tmp.splice(index, 1);
                        tmp.unshift(selected[0]);
                    }

                    setStashSelected(tmp);
                }
            } else {
                setFreePreview({});
            }
        },
        [stashSelected, freePreview]
    );

    const addSelectStash = (media_id, thumb_path, stashMedia) => {
        if (stashSelected.find((element) => element.media_id == media_id)) {
            const new_arr = stashSelected.filter(
                (element) => element.media_id != media_id
            );
            setStashSelected(new_arr);
        } else {
            const tmp = [...tmpStashSelection];
            tmp.push(media_id);
            setTmpStashSelection([...tmp]);
            const newMedia = {
                media_id,
                thumb_path,
                type: stashMedia.type,
                file_path: stashMedia.file_path,
                large_path: stashMedia.large_path,
            };
            setStashSelected([...stashSelected, newMedia]);
        }
    };

    const onStashClose = () => {
        if (onComposeMessage) {
            setOnComposeMessage(false);
        }
    };

    const openModal = (msgType = "", from = "") => {
        setStashShow(true);

        if (msgType === "broadcast" || from === "chat") {
            setOnComposeMessage(true);
        }

        if (msgType === "broadcast") {
            setOpenModalBroadcast(true);
        }
    };

    const getSettings = () => {
        const params = {
            only: "max_stash_file_uploads,min_ppv_price,max_ppv_price",
        };

        setSettings(params);
    };

    const togglePriceInput = () => {
        updateShowPrice(!showPrice);
    };

    const dispatchAlert = (body, type, title = "") => {
        dispatch(
            setAlert({
                body,
                type,
                title,
                show: true,
            })
        );
    };

    const onBack = () => {
        if (subTitle) {
            setSubTitle(null);
            setSelectedFilter("");
            setNewMsgStep("1");
        } else {
            if (newMsgStep == "1") {
                history.push("/messages");
            } else {
                setNewMsgStep("1");
            }
        }
    };

    const handleSelectedFilter = useCallback((value) => {
        setSelectedFilter(value);
        setNewMsgChecked(value);
    }, []);

    const submitBroadcast = () => {
        if (sending || disableBroadcastSendMessage) {
            return false;
        }

        if (stashSelected.length == 0 && ppvPrice > 0) {
            dispatchAlert("Please select at least one attachment", "error");
            return false;
        }

        if (stashSelected.length == 0 && broadcastMessage.trim().length <= 0) {
            dispatchAlert(
                "Please select at least one attachment or add a broadcast message",
                "error"
            );
            return false;
        }

        const hasFreePreview =
            freePreview && Object.keys(freePreview).length > 0;
        const numStashSelected = stashSelected.length;
        if (hasFreePreview && numStashSelected === 1) {
            dispatchAlert(
                "Free preview can only be used with multiple media",
                "error"
            );
            return false;
        }

        const myId = parseInt(localStorage.getItem("loggedin_user"));
        const formData = new FormData();
        formData.append("message", broadcastMessage);

        if (showPrice) {
            if (parseFloat(ppvPrice) < minPpvPrice) {
                setPpvPriceError(true);
                return false;
            }
            if (parseFloat(ppvPrice) > maxPpvPrice) {
                setPpvPriceError(true);
                return false;
            }
        }

        setSending(true);
        setShowLoader(true);
        if (ppvPrice > 0) {
            formData.append("ppv_price", ppvPrice);

            if (isDiscounted) {
                formData.append("promo_price", promoPrice);
                formData.append("expiry_date", JSON.stringify(expiry));
            }
        }

        formData.append("sender_id", myId);
        formData.append("broadcast_id", broadcastId);

        if (!newMsgChecked && isResend) {
            formData.append("broadcast_type", "resend");
        } else {
            formData.append("broadcast_type", newMsgChecked);
        }

        if (newMsgChecked == "new") {
            formData.append("new_subs_limit", lastSubsParent);
            formData.append("new_subs_pastHours", pastHoursParent);
        }

        stashSelected.map((file, index) => {
            formData.append("media[]", file.media_id);
        });

        newMsgSendSelected.map((k, i) => {
            formData.append("broadcast_list[]", k.id);
        });

        if (newMsgChecked === "subs_range") {
            const from = moment(rangeDateFromParent).format("YYYY-MM-DD");
            const to = moment(rangeDateToParent).format("YYYY-MM-DD");
            formData.append("range_id_from", rangeIdFromParent);
            formData.append("range_id_to", rangeIdToParent);
            formData.append("range_date_from", from);
            formData.append("range_date_to", to);
        }

        if (newMsgChecked === "user_lists") {
            formData.append(
                "list_ids",
                messageUserListsFilterRdx.map((uList) => uList.id)
            );
        }

        formData.append(
            "except",
            excluded.length > 0 ? excluded.map((e) => e.id).join(",") : ""
        );

        if (freePreview && Object.keys(freePreview).length > 0) {
            formData.append("free_preview", freePreview.media_id);
        }

        formData.append("send_by", sendBy);

        if (userInformation.role == ROLES.ADMIN) {
            formData.append("send_email", sendEmail);
        }

        updateBroadcastIndicator(true);

        const stashPayload = {
            stashSelected: [],
            tabSelected: "media",
            albumAction: "",
            stashSidebar: false,
            busy: false,
        };

        axios({
            method: "post",
            url: "/api/broadcast-message",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((data) => {
                setIsResend(false);

                /*
                if (refreshConvList) {
                    setRefreshConvList(false); // refresh conversation list
                } else {
                    setRefreshConvList(true);
                }
                setLoadMessageTrigger((loadMessageTrigger) => loadMessageTrigger += 1);
                */

                updateBroadcastIndicator(false);

                dispatch(resetMessageUserListsFilter());
            })
            .catch((error) => {
                console.error({ error });
                setSending(false);
                setShowLoader(false);
                updateBroadcastIndicator(false);
                if (error.response && error.response.status == 422) {
                    Object.keys(error.response.data.errors).forEach((key) => {
                        if (key == "ppv_price") {
                            setPpvPriceError(true);
                        }
                    });
                } else {
                    dispatch(
                        setAlert({
                            type: "error",
                            message: "Message not sent",
                            show: true,
                        })
                    );
                }
            });

        setTimeout(() => {
            resetBroadcastForm();
            setShowLoader(false);
            closeModal();
            setBroadcastModal(false);
            closeNewMsg();
            // setIsOpen(false);
            setNewMsgStep("1"); // reset to step 1
            setBroadcastMessage("");
            // setImages([]);
            setStashSelected([]);
            setPpvPriceError(false);
            //   setActive(active);
            updateShowPrice(false);
            setNewMsgSendSelected([]); // clear user selected for broadcast
            setAttach([]);
            setNewMsgChecked(""); // uncheck choices in send broadcast
            updateBroadcastMsg("");
            setSending(false);
            setExcluded([]);
            // setStash(stashPayload);
        }, 800);
    };

    const clearLocationState = () => {
        // Extract pathname, search, and hash from current location
        const { pathname, search, hash } = location;

        // Create a new location object without state
        const newLocation = {
            pathname,
            search,
            hash,
        };

        // Replace current location with the new one without state
        history.replace(newLocation);
    };

    // @TODO: check
    const closeNewMsg = () => {
        resetBroadcastForm();
        // setMsgModalIsOpen(false);
        setStashSelected([]);
        setBroadcastModal(false);
        setNewMsgStep("1");
        setSelectedFilter("");
        setNewMsgSendSelected([]);
        dispatch(setTempSelected([]));
        setNewMsgChecked("");
        clearLocationState();
    };

    const handleNextStep = (e) => {
        const count = newMsgSendSelected.length;
        if (newMsgChecked === "new") {
            // check new subscribers only
            axios
                .get("/api/fetchConvs", {
                    params: {
                        user_filter: newMsgChecked,
                        last_hrs: lastHrs,
                    },
                })
                .then(({ data }) => {
                    setNextLoading(false);

                    if (data.data.length == 0) {
                        setNewMsgSendSelected([]);
                        if (newMsgChecked != "new") {
                            setNewMsgChecked("");
                        }

                        setNextLoading(true);
                        axios
                            .get("/api/fetch-latest-sub", {
                                params: {
                                    user_filter: newMsgChecked,
                                    last_hrs: lastHrs,
                                },
                            })
                            .then(({ data }) => {
                                setNextLoading(false);
                                if (data.hours_diff > 0) {
                                    const timeDiff = splitTime(data.hours_diff);
                                    let inWords = "";
                                    if (timeDiff.days) {
                                        inWords += `${timeDiff.days} day${
                                            timeDiff.days > 1 ? "s" : ""
                                        }`;
                                    }
                                    if (timeDiff.hours) {
                                        inWords += ` ${timeDiff.hours} hour${
                                            timeDiff.hours > 1 ? "s" : ""
                                        }`;
                                    }
                                    if (timeDiff.minutes) {
                                        inWords += ` and ${
                                            timeDiff.minutes
                                        } minute${
                                            timeDiff.minutes > 1 ? "s" : ""
                                        }`;
                                    }
                                    dispatch(
                                        setAlert({
                                            type: "success",
                                            show: true,
                                            body: `No new subscribers in last ${data.last_hours} hour(s). The last user subscribed ${inWords} ago`,
                                        })
                                    );
                                } else {
                                    dispatch(
                                        setAlert({
                                            type: "error",
                                            show: true,
                                            body: "No followers found.",
                                        })
                                    );
                                }
                            })
                            .catch((error) => {
                                console.error({ error });
                                setNextLoading(false);
                                dispatch(
                                    setAlert({
                                        type: "error",
                                        show: true,
                                        body: "No followers found.",
                                    })
                                );
                            });
                    } else {
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    }
                })
                .catch((error) => {
                    console.error({ error });
                    setNextLoading(false);
                });
        } else if (newMsgChecked == "new_last_subs") {
            setNextLoading(true);
            axios
                .get("/api/fetch-latest-sub", {
                    params: {
                        user_filter: newMsgChecked,
                        last_subs: lastSubs,
                    },
                })
                .then(({ data }) => {
                    setNextLoading(false);
                    if (data.active <= 0) {
                        dispatch(
                            setAlert({
                                type: "error",
                                show: true,
                                body: "No followers found.",
                            })
                        );
                    } else {
                        if (lastSubs > data.active) {
                            setLastSubs(data.active);
                            setUserCount(lastSubs);
                        } else {
                            setUserCount(lastSubs);
                        }
                        setNewMsgStep("2");
                    }
                })
                .catch((error) => {
                    console.error({ error });
                    setNextLoading(false);
                    dispatch(
                        setAlert({
                            type: "error",
                            show: true,
                            body: "No followers found.",
                        })
                    );
                });
        } else if (newMsgChecked === "unsubscribed") {
            setNextLoading(true);

            axios
                .get("/api/fetchConvs", {
                    params: {
                        user_filter: newMsgChecked,
                    },
                })
                .then(({ data }) => {
                    setNextLoading(false);
                    if (data && data.data.length > 0) {
                        setNewSubsError("");
                        const setSendList = data.data.map((i) => ({
                            name: i.other_user,
                            id: i.other_user_id,
                        }));
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    } else {
                        dispatch(
                            setAlert({
                                type: "error",
                                show: true,
                                body: "You have no unsubscribed followers",
                            })
                        );
                        setNewMsgStep("1");
                    }
                })
                .catch((error) => {
                    console.error({ error });
                    setNextLoading(false);
                });
        } else if (newMsgChecked == "favourites") {
            setNextLoading(true);

            axios
                .get("/api/fetchConvs", {
                    params: {
                        user_filter: newMsgChecked,
                    },
                })
                .then(({ data }) => {
                    setNextLoading(false);
                    if (data.data && data.data.length > 0) {
                        setNewSubsError("");
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    } else {
                        dispatch(
                            setAlert({
                                type: "error",
                                show: true,
                                body: "You have no favourite followers",
                            })
                        );
                        setNewMsgStep("1");
                    }
                })
                .catch((error) => {
                    console.error({ error });
                    setNextLoading(false);
                });
        } else if (
            newMsgChecked === "subs_range_date" ||
            newMsgChecked === "subs_range_id"
        ) {
            let params = {
                user_filter: newMsgChecked,
            };
            params =
                newMsgChecked === "subs_range_id"
                    ? {
                          ...params,
                          range_id_from: rangeIdFrom,
                          range_id_to: rangeIdTo,
                      }
                    : {
                          ...params,
                          range_date_from: rangeDateFrom,
                          range_date_to: rangeDateTo,
                      };
            setNextLoading(true);
            axios
                .get("/api/fetch-latest-sub", {
                    params,
                })
                .then(({ data }) => {
                    setNextLoading(false);
                    if (data.data && data.data.length > 0) {
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    } else {
                        dispatch(
                            setAlert({
                                type: "error",
                                show: true,
                                body: "You have no subscribed followers for selected range.",
                            })
                        );
                    }
                })
                .catch((error) => {
                    console.error({ error });
                    setNextLoading(false);
                });
        } else {
            setNewMsgStep("2");
        }
    };

    useEffect(() => {
        if (newMsgStep == 1) {
            setTitle("New Message");
        }

        if (newMsgStep == 2) {
            setTitle(
                `Send message to ${
                    userDetails &&
                    [ROLES.PU, ROLES.ADMIN].includes(userDetails.role)
                        ? userCount
                        : newMsgSendSelected.length
                } user(s)`
            );
        }
    }, [newMsgStep]);

    const handleKeySend = (event) => {
        if (event.shiftKey && isDesktop) {
            if (event.key === "Enter") {
                let tmp = JSON.parse(JSON.stringify(broadcastMessage));
                tmp += "\n";

                setBroadcastMessage(tmp);

                return;
            }
        }

        if ((event.key === "Enter" || event.keyCode === 13) && isDesktop) {
            event.preventDefault();
            submitBroadcast();
        }
    };

    const onChangeInputBroadcastStr = (ecaption) => {
        setBroadcastMessage(ecaption);
    };

    const resetPriceModal = () => {
        setPpvPrice("");
        setPromoPrice("");
        resetExpiry();
        setIsDiscounted(false);
        setPrevPpvPrice("");
        setPrevPromoPrice("");
        resetPrevExpiry();
        setPrevIsDiscounted(false);
    };

    const resetPrevExpiry = () => {
        setPrevExpiry({
            days: 0,
            hours: 0,
            minutes: 0,
        });
    };

    const handlePriceModalClose = (param = "") => {
        if (param) {
            if (param === "ok") {
                setPrevPpvPrice(ppvPrice);
                setPrevPromoPrice(promoPrice);
                setPrevExpiry(expiry);
                setPrevIsDiscounted(isDiscounted);
            } else if (param === "cancel") {
                if (prevPpvPrice) {
                    setPpvPrice(prevPpvPrice);
                    setPromoPrice(prevPromoPrice);
                    setExpiry(prevExpiry);
                    setIsDiscounted(prevIsDiscounted);
                } else {
                    resetPriceModal();
                }
            }
        } else {
            if (!ppvPrice) {
                setIsDiscounted(false);
                setPrevPpvPrice("");
                setPrevPromoPrice("");
                resetPrevExpiry();
                setPrevIsDiscounted(false);
            }
        }

        updateShowPrice(false);
    };

    const resetExpiry = () => {
        setExpiry({
            days: 0,
            hours: 0,
            minutes: 0,
        });
    };

    useEffect(() => {
        if (settings && Object.keys(settings).length > 0) {
            setMinPpvPrice(parseFloat(settings.min_ppv_price));
            setMaxPpvPrice(parseFloat(settings.max_ppv_price));
        }
    }, [settings]);

    useEffect(() => {
        getSettings();

        // #todo:
        if (location.state && location.state.isResend) {
            setIsResend(location.state.isResend);
            handleResend(location.state.response);
        }
    }, []);

    useEffect(() => {
        if (
            stashSelected.length > 0 ||
            (broadcastMessage !== "" && stashSelected.length === 0)
        ) {
            setDisableBroadcastSendMessage(false);
        } else {
            setDisableBroadcastSendMessage(true);
        }

        if (stashSelected.length > 0 && showPrice && ppvPrice === "") {
            setDisableBroadcastSendMessage(true);
        }

        if (sending) {
            setDisableBroadcastSendMessage(true);
        }

        if (ppvPrice > 0 && stashSelected.length === 0) {
            setDisableBroadcastSendMessage(true);
        }
    }, [
        sending,
        ppvPriceError,
        showPrice,
        ppvPrice,
        stashSelected,
        broadcastMessage,
    ]);

    const handleResend = (response) => {
        dispatch(setTempSelected([]));
        setResending(false);

        // if (response && response.length > 0) {
        setStashShow(false);
        setIsResend(true);
        // setMsgModalIsOpen(true);

        const sendList = response.receivers.map((receiver) => ({
            name: receiver.login,
            id: receiver.id,
        }));

        setNewMsgSendSelected(sendList);
        updateShowPrice(true);
        setBroadcastModal(true);
        setNewMsgStep("2");
        setUserCount(sendList.length);
        setPpvPrice(response.message.price);
        updateBroadcastMsg(response.message.message);
        setBroadcastMessage(response.message.message);
        setStashSelected(response.message.medias);
        setTmpStashSelection(response.message.medias);
        setStashSidebar(false);

        // setting free preview
        // @TODO: update this when we allow multiple free previews
        const resultMedia = response.message.medias;
        const resultFreeMedia =
            resultMedia && resultMedia.length > 0
                ? resultMedia.find((media) => media.free_preview)
                : {};
        if (resultFreeMedia && Object.keys(resultFreeMedia).length > 0) {
            setFreePreview(resultFreeMedia);
        }
        // }
    };

    useDidMountEffect(() => {
        setFreePreview(stashSelected[0]);
    }, [reshuffled]);

    const handlePriceInformationClose = () => {
        setPpvPrice("");
        setPromoPrice("");
        // setExpiryDate(moment().add(1, 'hours'));
        setIsDiscounted(false);
        setPrevPpvPrice("");
        setPrevPromoPrice("");
        // setPrevExpiryDate(moment().add(1, 'hours'));
        setPrevIsDiscounted(false);
        updateShowPrice(false);
    };

    const closeModal = (isAdd = "") => {
        setStashModal(false);
        setStashSidebar(false);

        if (isAdd == "add") {
            setTmpStashSelection([]);
        }

        if (isAdd != "add") {
            let tmp = [...stashSelected];
            tmp = tmp.filter((t) => tmpStashSelection.indexOf(t.media_id) < 0);
            setStashSelected([...tmp]);
            setTmpStashSelection([]);
        }

        if (openModalBroadcast) {
            setOpenModalBroadcast(false);
        }
    };

    const getExcludeOptions = () => {
        axios
            .get("/api/fetchConvs", {
                params: {
                    all: true,
                    exclude: true,
                },
            })
            .then((response) => {
                setExcludeList(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        if (selectedFilter) {
            getExcludeOptions();
        }
        let filter = "";
        switch (selectedFilter) {
            case "all_send":
                filter = "All Subscribers";
                break;
            case "new":
                filter = "New Subscribers";
                break;
            case "subs_range":
                filter = "Subscriber Range";
                break;
            case "unsubscribed":
                filter = "Unsubscribed";
                break;
            case "favourites":
                filter = "Favourites";
                break;
            case "online":
                filter = "Online";
                break;
            case "user_lists":
                filter = "User Lists";
                break;

            default:
                filter = "";
        }

        setSubTitle(filter);
    }, [selectedFilter]);

    const handleSendEmailChange = (e) => {
        setSendEmail(!sendEmail);
    };

    return (
        <div className="container pt-4">
            <Meta title="New Message" />

            <Grid2 container spacing={!isMobile ? 2 : 0}>
                <Grid2 md={8}>
                    <div className="new-message">
                        <div style={{ marginBottom: 12 }}>
                            <PageHeader
                                title={title}
                                subTitle={
                                    newMsgStep == 1 && subTitle
                                        ? subTitle
                                        : null
                                }
                                backable={true}
                                onBack={onBack}
                                busy={nextLoading}
                                closePath={"/messages"}
                            />
                        </div>

                        <div className="new-message__content">
                            {newMsgStep == 1 ? (
                                <div className={`new-msg-step1`}>
                                    <div className="filter">
                                        <div className=" attireBlock mod1 filter__search">
                                            {selectedFilter == "" ? (
                                                <div
                                                    css={css`
                                                        margin: 15px auto 40px
                                                            auto;
                                                        width: 100%;

                                                        @media (min-width: 900px) {
                                                            width: 50%;
                                                        }
                                                    `}
                                                >
                                                    <form
                                                        className="attireCodeToggleBlock"
                                                        action=""
                                                    >
                                                        <NewMessageUserMultiSelect
                                                            newMsgSendSelected={
                                                                newMsgSendSelected
                                                            }
                                                            setNewMsgSendSelected={
                                                                setNewMsgSendSelected
                                                            }
                                                            disabled={
                                                                selectedFilter !=
                                                                ""
                                                            }
                                                        />
                                                    </form>
                                                </div>
                                            ) : null}
                                        </div>

                                        {userDetails &&
                                            userDetails.role == ROLES.SU && (
                                                <div className="next-btn mt-2">
                                                    {(newMsgSendSelected.length !==
                                                        0 ||
                                                        newMessageSelect !==
                                                            0) && (
                                                        <table
                                                            cellSpacing={0}
                                                            cellPadding={0}
                                                            border="0"
                                                            width="100%"
                                                        >
                                                            <tbody>
                                                                <tr>
                                                                    <td width="90%">
                                                                        &nbsp;
                                                                    </td>
                                                                    <td
                                                                        align="right"
                                                                        style={{
                                                                            textAlign:
                                                                                "right",
                                                                            padding:
                                                                                "0 15px",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            id="nxtbtn"
                                                                            onClick={
                                                                                handleNextStep
                                                                            }
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            style={{
                                                                                float: "right",
                                                                            }}
                                                                        >
                                                                            Next
                                                                        </button>
                                                                        <div
                                                                            style={{
                                                                                clear: "both",
                                                                            }}
                                                                        ></div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </div>
                                            )}

                                        <MessageContext.Provider
                                            value={{
                                                sendBy,
                                                setSendBy,
                                                setNewMsgChecked,
                                            }}
                                        >
                                            {userDetails &&
                                                [
                                                    ROLES.PU,
                                                    ROLES.ADMIN,
                                                ].includes(
                                                    userDetails.role
                                                ) && (
                                                    <BroadcastFilter
                                                        setSelectedFilter={
                                                            handleSelectedFilter
                                                        }
                                                        selectedFilter={
                                                            selectedFilter
                                                        }
                                                        setNewMsgStep={
                                                            setNewMsgStep
                                                        }
                                                        setUserCount={
                                                            setUserCount
                                                        }
                                                        setNewMsgSendSelected={
                                                            setNewMsgSendSelected
                                                        }
                                                        newMsgSendSelected={
                                                            newMsgSendSelected
                                                        }
                                                        setRangeIdFromParent={
                                                            setRangeIdFromParent
                                                        }
                                                        setRangeIdToParent={
                                                            setRangeIdToParent
                                                        }
                                                        setLastSubsParent={
                                                            setLastSubsParent
                                                        }
                                                        setPastHoursParent={
                                                            setPastHoursParent
                                                        }
                                                        setRangeDateFromParent={
                                                            setRangeDateFromParent
                                                        }
                                                        setRangeDateToParent={
                                                            setRangeDateToParent
                                                        }
                                                        excluded={excluded}
                                                        sus={excludeList}
                                                        setExcluded={
                                                            setExcluded
                                                        }
                                                        subTitle={subTitle}
                                                    />
                                                )}
                                        </MessageContext.Provider>

                                        {newMsgChecked == "new" &&
                                            newSubsError && (
                                                <div className="new_sub_error">
                                                    {newSubsError}
                                                    {newSubsError != "" && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-subs-error"
                                                            onClick={() =>
                                                                confirmSubsError()
                                                            }
                                                        >
                                                            OK
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                    </div>
                                </div>
                            ) : null}

                            {newMsgStep == 2 ? (
                                <div className={`new-msg-step2`}>
                                    <div className="chat-action">
                                        {userInformation.role == ROLES.ADMIN ? (
                                            <div
                                                css={css`
                                                    margin: 0 10px;
                                                    text-align: left;
                                                `}
                                            >
                                                <FormControlLabel
                                                    label="Send Email"
                                                    control={
                                                        <Checkbox
                                                            checked={sendEmail}
                                                            onChange={
                                                                handleSendEmailChange
                                                            }
                                                            inputProps={{
                                                                "aria-label":
                                                                    "controlled",
                                                            }}
                                                        />
                                                    }
                                                />
                                            </div>
                                        ) : null}
                                        {ppvPrice > 0 ? (
                                            <PriceInformation className="create-ppv-price">
                                                <div>
                                                    <span>
                                                        Price:{" "}
                                                        <PriceText
                                                            price={ppvPrice}
                                                            discountedPrice={
                                                                promoPrice
                                                            }
                                                            isDiscounted
                                                        />{" "}
                                                        {promoPrice &&
                                                        isDiscounted ? (
                                                            <React.Fragment>
                                                                {" "}
                                                                Limited offer
                                                                expires in{" "}
                                                                {expiry.days > 0
                                                                    ? expiry.days >
                                                                      1
                                                                        ? `${expiry.days} days `
                                                                        : "1 day "
                                                                    : ""}{" "}
                                                                {expiry.hours >
                                                                0
                                                                    ? expiry.hours >
                                                                      1
                                                                        ? `${expiry.hours} hrs `
                                                                        : "1 hr "
                                                                    : ""}{" "}
                                                                {expiry.minutes >
                                                                0
                                                                    ? expiry.minutes >
                                                                      1
                                                                        ? `${expiry.minutes} mins `
                                                                        : "1 min"
                                                                    : ""}
                                                            </React.Fragment>
                                                        ) : (
                                                            ""
                                                        )}{" "}
                                                    </span>
                                                </div>
                                                <ClosePriceInformation>
                                                    <IconButton
                                                        color="primary"
                                                        onClick={
                                                            handlePriceInformationClose
                                                        }
                                                    >
                                                        <i className="fal fa-times search-clear-icon"></i>
                                                    </IconButton>
                                                </ClosePriceInformation>
                                            </PriceInformation>
                                        ) : (
                                            ""
                                        )}
                                        <div className="act-reply-bx">
                                            <div className="act-text um-message-textarea">
                                                <PTextareaBroadcast
                                                    placeholder={
                                                        "Type your message"
                                                    }
                                                    onKeyDown={handleKeySend}
                                                    updateBroadcastMsg={
                                                        onChangeInputBroadcastStr
                                                    }
                                                    setNewLineCount={
                                                        setNewLineCount
                                                    }
                                                    resetPriceModal={
                                                        resetPriceModal
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {/* Broadcast message */}
                                        <div className="chat-buttons">
                                            <div className="chat-buttons-left">
                                                {userDetails &&
                                                [
                                                    ROLES.PU,
                                                    ROLES.ADMIN,
                                                ].includes(userDetails.role) ? (
                                                    <span
                                                        className={`chat-btn-cont send-message-chat`}
                                                        onClick={() =>
                                                            openModal(
                                                                "broadcast"
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-regular fa-photo-film"></i>
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={`chat-btn-cont`}
                                                        {...getRootProps()}
                                                    >
                                                        <input
                                                            {...getInputProps()}
                                                        />
                                                        {isDragActive ? (
                                                            <p>
                                                                Drop the files
                                                                here ...
                                                            </p>
                                                        ) : (
                                                            <i className="fa-regular fa-photo-film"></i>
                                                        )}
                                                    </span>
                                                )}

                                                {userDetails &&
                                                    [
                                                        ROLES.PU,
                                                        ROLES.ADMIN,
                                                    ].includes(
                                                        userDetails.role
                                                    ) && (
                                                        <span
                                                            className={`chat-btn-cont${
                                                                showPrice
                                                                    ? " active"
                                                                    : ""
                                                            }`}
                                                            onClick={
                                                                togglePriceInput
                                                            }
                                                        >
                                                            <i className="fa-regular fa-circle-dollar"></i>
                                                        </span>
                                                    )}

                                                {ppvPrice > 0 ? (
                                                    ""
                                                ) : userDetails &&
                                                  userDetails.role == 1 ? (
                                                    <span className="ppv-text">
                                                        Pay Per View{" "}
                                                    </span>
                                                ) : (
                                                    ""
                                                )}

                                                <div className="broadcast-send">
                                                    <button
                                                        className="btn btn-sm btn-primary btn-rounded"
                                                        onClick={
                                                            submitBroadcast
                                                        }
                                                        disabled={
                                                            disableBroadcastSendMessage
                                                        }
                                                    >
                                                        Send
                                                    </button>
                                                </div>
                                            </div>

                                            {showPrice && (
                                                <div
                                                    className="dropdown-menu attachment-reminder"
                                                    style={
                                                        stashSelected.length ==
                                                        0
                                                            ? {
                                                                  display:
                                                                      "inline",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span
                                                        className={`um-message-item-remove ir66 um-message-item-show-on-hover um-tip-s`}
                                                    >
                                                        Attach media file/s
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        {/* </form> */}
                                    </div>

                                    {!stashSidebar && (
                                        <>
                                            {files.length > 0 ? (
                                                <div className="messenger-attachments">
                                                    {/* Loop this one for multiple */}
                                                    {files.map((i, k) => (
                                                        <div
                                                            key={`img-${k}`}
                                                            className="msg-a-item"
                                                        >
                                                            <span
                                                                className="close remove-stash"
                                                                onClick={() =>
                                                                    removeItem(
                                                                        k
                                                                    )
                                                                }
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={[
                                                                        "fas",
                                                                        "times",
                                                                    ]}
                                                                />
                                                            </span>
                                                            <div
                                                                className="msg-img"
                                                                style={{
                                                                    backgroundImage: `url(${URL.createObjectURL(
                                                                        i
                                                                    )})`,
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="bobex">
                                                    {stashSelected.length >
                                                        0 && (
                                                        <button
                                                            className="btn btn-dark uploadBtn"
                                                            onClick={() => {
                                                                uploadFiles(
                                                                    this
                                                                );
                                                            }}
                                                        >
                                                            Upload
                                                        </button>
                                                    )}

                                                    {stashSelected.length >
                                                    0 ? (
                                                        <>
                                                            <div className="images ppv-images-cont">
                                                                {stashSelected?.length >
                                                                    0 && (
                                                                    <StashSelected
                                                                        medias={
                                                                            stashSelected
                                                                        }
                                                                        addSelectStash={
                                                                            addSelectStash
                                                                        }
                                                                        handleSelectFreePreview={
                                                                            handleSelectFreePreview
                                                                        }
                                                                        freePreview={
                                                                            freePreview
                                                                        }
                                                                        ppvPrice={
                                                                            ppvPrice
                                                                        }
                                                                        setStashSelected={
                                                                            setStashSelected
                                                                        }
                                                                        setReshuffled={
                                                                            setReshuffled
                                                                        }
                                                                        reshuffled={
                                                                            reshuffled
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="no-images">
                                                            <h5 className="text-center" />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            ) : null}
                        </div>

                        <ModalPPVPriceContext.Provider
                            value={{
                                showPrice,
                                handlePriceModalClose,
                                ppvPrice,
                                setPpvPrice,
                                promoPrice,
                                setPromoPrice,
                                isDiscounted,
                                setIsDiscounted,
                                minPpvPrice,
                                maxPpvPrice,
                                prevPpvPrice,
                                prevPromoPrice,
                                prevIsDiscounted,
                                setPrevPpvPrice,
                                setPrevPromoPrice,
                                setPrevIsDiscounted,
                                expiry,
                                setExpiry,
                                dispatchAlert,
                            }}
                        >
                            <ModalPPVPrice />
                        </ModalPPVPriceContext.Provider>

                        {show && (
                            <Stash
                                source="messenger"
                                resend={handleResend}
                                resetOnClose={false}
                                onMessageOrPost={onComposeMessage}
                                onStashClose={onStashClose}
                                resending={resending}
                            />
                        )}
                    </div>
                </Grid2>

                {!isMobile ? (
                    <Grid2 className="new-message__right" md={4}></Grid2>
                ) : null}
            </Grid2>
        </div>
    );
};

const mapStateToProps = (state) => ({
    userDetails: state.user.user,
    stashSidebar: state.stash.stashSidebar,
    userListsRdx: state.userLists.userLists,
    showPrice: state.message.showPrice,
    stashModal: state.message.stashModal,
    settings: state.privaGlobal.settings,
    stashSelected: state.stash.stashSelected,
    stashSidebar: state.stash.stashSidebar,
    broadcastModal: state.message.broadcastModal,
    show: state.stash.show,
    messageUserListsFilterRdx: state.message.userListsFilter,
});

const mapDispatchToProps = (dispatch) => ({
    setStashSelected: (stashSelected) =>
        dispatch(setStashSelectedR(stashSelected)),
    updateShowPrice: (showPrice) => dispatch(updateShowPriceR(showPrice)),
    setSettings: (params) => dispatch(setSettings(params)),
    setBroadcastModal: (broadcastModal) =>
        dispatch(setBroadcastModal(broadcastModal)),
    setStashShow: (params) => dispatch(setStashShow(params)),
    updateBroadcastIndicator: (payload) =>
        dispatch(updateBroadcastIndicator(payload)),
    setStashTabSelected: (payload) => dispatch(setStashTabSelected(payload)),
    updateBroadcastMsg: (broadcastMsg) =>
        dispatch(updateBroadcastMsgR(broadcastMsg)),
    setStashModal: (stashModal) => dispatch(setStashModal(stashModal)),
    setStashSidebar: (stashSidebar) => dispatch(setStashSidebar(stashSidebar)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewMessage);
